export default __webpack_public_path__ + "static/media/4T0A9352.b2ed6781.jpg";